import { type RefObject, useEffect, useRef, useState } from 'react';
import type { BattleEngine } from './useBattleCanvas';
import { playSfx } from './sfx';

const BEEP_FROM = 3;

// WHY: DECISION_S должен оставаться короче серверного ROUND_TIMEOUT_MS
export const DECISION_S = 10;

export function useRoundTimer(
  engineRef: RefObject<BattleEngine | null>,
  round: number,
  over: boolean,
  onExpire: () => void,
): { remain: number; replayLocked: boolean } {
  const [remain, setRemain] = useState(DECISION_S);
  const [lock, setLock] = useState({ round, locked: true });
  const replayLocked = lock.round !== round || lock.locked;
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;
  const lastBeepRef = useRef(0);

  useEffect(() => {
    if (over) return;
    lastBeepRef.current = 0;
    setLock({ round, locked: true });
    setRemain(DECISION_S);
    const id = window.setInterval(() => {
      const engine = engineRef.current;
      if (!engine || engine.getActiveRound() !== round) return;
      const replayDur = engine.getReplayDur();
      const elapsed = performance.now() / 1000 - engine.getActiveAt();
      const locked = elapsed < replayDur;
      setLock({ round, locked });
      const dec = locked ? DECISION_S : replayDur + DECISION_S - elapsed;
      const secs = Math.max(0, Math.ceil(dec));
      setRemain(secs);
      if (!locked && secs > 0 && secs <= BEEP_FROM && secs !== lastBeepRef.current) {
        lastBeepRef.current = secs;
        playSfx('timer_beep', 0.5);
      }
      if (!locked && dec <= 0) onExpireRef.current();
    }, 150);
    return () => window.clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [round, over]);

  return { remain, replayLocked };
}
